import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  const loadingTimeout = setTimeout(() => {
    pageContent.classList.add("is-loading");
  }, 300);

  const res = await ajax.get(window.location.href).json();

  clearTimeout(loadingTimeout);

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
    form.classList.add("is-filtered");
  } else {
    form.classList.remove("is-filtered");
  }
};

const handleFilter = (e) => {
  const url = updateQueryParams([[e.target.name, e.target.value]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleSearch = (e) => {
  e.preventDefault();

  const formData = new FormData(form);
  const searchTerm = formData.get("search");

  if (searchTerm !== "") {
    const url = updateQueryParams([["search", searchTerm]]);

    window.history.replaceState({}, "", url);

    updateResults();
  }
};

const handleFilterClear = (e) => {
  e.preventDefault();

  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
  form.querySelectorAll("input:checked").forEach((x) => (x.checked = false));

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate('.filter-form input[type="radio"]', "change", handleFilter);
    delegate(".filter-form", "submit", handleSearch);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }
});
